import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", {
  class: "qh-icon-link-nav"
}, null, -1);
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "复制链接", -1);
const _hoisted_3 = [_hoisted_1, _hoisted_2];
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", {
  class: "qh-icon-delete-nav"
}, null, -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "删除", -1);
const _hoisted_6 = [_hoisted_4, _hoisted_5];
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "qh-icon-warn-nav"
}, null, -1);
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "举报", -1);
const _hoisted_9 = [_hoisted_7, _hoisted_8];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("footer", {
    class: _normalizeClass({
      footer: true,
      isIos: _ctx.checkIsIos
    })
  }, [_createElementVNode("a", {
    href: "javascript:;",
    class: _normalizeClass({
      'is-disabled': _ctx.copyList.length === 0
    }),
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.handleCopy && _ctx.handleCopy(...args))
  }, _hoisted_3, 2), _createElementVNode("a", {
    href: "javascript:;",
    class: _normalizeClass({
      'is-disabled': _ctx.selects.length === 0
    }),
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    (...args) => _ctx.handleDel && _ctx.handleDel(...args))
  }, _hoisted_6, 2), _createElementVNode("a", {
    href: "javascript:;",
    class: _normalizeClass({
      'is-disabled': _ctx.num !== 1
    }),
    onClick: _cache[2] || (_cache[2] =
    //@ts-ignore
    (...args) => _ctx.handleReport && _ctx.handleReport(...args))
  }, _hoisted_9, 2)], 2);
}